import React from 'react';
import styles from './TextIconCards.module.scss';
import Img from '@/components/Img';
import { normalizeHtmlStyles } from '@/normalizeHtmlStyles';

interface TextIconCardsProps {
  data: {
    cards: {
      id: string;
      title: string;
      content: string;
      icon: {
        url: string;
      }
    }[]
  }
}
const TextIconCards = ({ data }: TextIconCardsProps) => (
  <section className={styles.rowDescriptionWithIcon}>
    {data.cards.map((item) => (
      <div
        key={item.title}
        className={styles.row}
      >
        <div className={styles.content}>
          <h4 className={styles.title}>{item.title}</h4>
          <div
            className='htmlEditorContent'
            dangerouslySetInnerHTML={{
              __html: normalizeHtmlStyles(item.content),
            }}
          />
        </div>
        <Img
          src={item.icon.url}
          height={124}
          width={124}
          className={styles.icon}
        />
      </div>
    ))}
  </section>
);

export default TextIconCards;
